module.exports = __webpack_public_path__ + "img/TUR-B-2-II.e4d944f2.png";